export default __webpack_public_path__ + "static/media/a.07103d4d.svg";